<template>
  <form action="">
    <div class="modal-card" style="width: 600px">
      <header class="modal-card-head has-background-warning">
        <p class="modal-card-title">Agregar cotizacion</p>
        <button type="button" class="delete" @click="$emit('close', 'cotiza')" />
      </header>
      <section class="modal-card-body">
        <p class="is-size-1 has-text-weight-bold">Total ${{ formatoMonto(totalConImpuesto) }}</p>
        <busqueda-cliente @seleccionado="onSeleccionado" />

        <b-table class="mt-3" :data="productosLocal" striped>
          <b-table-column field="codigo" label="Código" v-slot="p">
            {{ p.row.codigo }}
          </b-table-column>
          <b-table-column field="nombre" label="Producto" v-slot="p">
            {{ p.row.nombre }}
          </b-table-column>
          <b-table-column field="cantidad" label="Cant." v-slot="p">
            {{ p.row.cantidad }}
          </b-table-column>
          <b-table-column field="precio" label="Precio" v-slot="p">
            ${{ formatoMonto(p.row.precio) }}
          </b-table-column>
          <b-table-column field="impuesto" label="Impuesto" v-slot="p">
            <b-select v-model="p.row.tipoImpuesto" size="is-small">
              <option value="exento">Exento</option>
              <option value="iva">IVA 16%</option>
              <option value="igtf">IGTF 3%</option>
            </b-select>
          </b-table-column>
        </b-table>

        <b-field class="mt-3" label="Válido hasta">
          <b-input type="date" v-model="hasta" />
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <b-button label="Cancelar" icon-left="cancel" size="is-medium" @click="$emit('close', 'cotiza')" />
        <b-button label="Guardar cotización" type="is-dark" icon-left="ticket-outline" size="is-medium"
          @click="guardarCotizacion" />
      </footer>
    </div>
  </form>
</template>
<script>
import BusquedaCliente from '../Clientes/BusquedaCliente'
import Utiles from '../../Servicios/Utiles'

  export default {
  name: "DialogoCotizar",
  props: ['totalVenta', 'listaProductos'],
  components: { BusquedaCliente },

  data: () => ({
    cliente: {},
    hasta: null,
    productosLocal: [],
  }),

  watch: {
    listaProductos: {
      immediate: true,
      handler (val)
      {
        if (!Array.isArray(val)) {
          this.productosLocal = []
          return
        }
        this.productosLocal = val.map(p => ({
          ...p,
          tipoImpuesto: p.tipoImpuesto || 'exento',
        }))
      },
    },
  },

  computed: {
    totalConImpuesto ()
    {
      return this.productosLocal.reduce((s, p) => {
        const line = parseFloat(p.cantidad) * parseFloat(p.precio)
        const tipo = p.tipoImpuesto || 'exento'
        let imp = 0
        if (tipo === 'iva') imp = line * 0.16
        else if (tipo === 'igtf') imp = line * 0.03
        return s + line + imp
      }, 0)
    },
  },

  methods: {
    formatoMonto (valor)
    {
      return Utiles.formatoMonto(valor)
    },

    onSeleccionado (cliente)
    {
      this.cliente = cliente
    },

    guardarCotizacion ()
    {
      if (Object.keys(this.cliente).length === 0) {
        this.$buefy.toast.open({
          type: 'is-danger',
          message: 'Debes seleccionar un cliente.'
        })
        return
      }

      if (!this.hasta) {
        this.$buefy.toast.open({
          type: 'is-danger',
          message: 'Debes añadir una fecha de "Válido hasta".'
        })
        return
      }

      let payload = {
        tipo: 'cotiza',
        cliente: this.cliente,
        hasta: this.hasta,
        productos: this.productosLocal,
      }

      this.$emit("terminar", payload)
    }
  }
}
</script>
